export default __webpack_public_path__ + "static/media/content-management.88c81467.svg";